import { render, staticRenderFns } from "./schedule-groupappointmentlist.vue?vue&type=template&id=978027a4&"
import script from "./schedule-groupappointmentlist.vue?vue&type=script&lang=js&"
export * from "./schedule-groupappointmentlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports